// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".quiz-gift-how-it-works__button[data-v-75575e71]{position:relative;top:20px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
